export default {
    baseStyle: {
        container: {
            width: 'auto'
        },
        triggerButton: {
            justifyContent: 'space-between'
        },
        label: {
            textStyle: 'labelSmMd',
            whiteSpace: 'nowrap',
            color: 'webTypo.textPrimary'
        },
        dividerWrapper: {
            height: '12px'
        },
        divider: {
            w: '1px',
            h: '12px',
            bg: 'webTheme.strokeDefault'
        },
        selectedLabel: {
            textStyle: 'bodySmRegular',
            color: 'webTypo.textSecondary'
        },
        popoverContent: {
            inset: '0px 0px auto auto',
            minWidth: '288px'
        },
        optionButton: {
            justifyContent: 'start',
            borderColor: 'webTheme.strokeTertiary'
        },
        selectedOptionButton: {
            position: 'relative',
            cursor: 'auto',
            _before: {
                content: '""',
                position: 'absolute',
                right: '15px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M16.6634 5L7.49674 14.1667L3.33008 10' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") no-repeat center center/20px;`,
                width: '20px',
                height: '20px'
            }
        }
    }
}
